import LoadingSpinner from "../../images/icon_loading_green.gif";
import Modal from "../Modal/Modal";
import { CancelButton, Container, MainButton } from "./ConfimModalStyles";

function ConfirmModal(props) {
  const {
    haveAccept,
    haveCancel,
    labelOnAccept,
    labelOnCancel,
    message,
    onAccept,
    onCancel,
    styleOnAccept,
    styleOnCancel,
    title,
    toggleModal,
    waitingForServerResponse,
  } = props;

  return (
    <Modal
      onOutsideClick={() => {
        toggleModal();
      }}
    >
      <Container>
        <h1>{title}</h1>
        <p>{message}</p>
        {haveAccept && (
          <MainButton
            onClick={onAccept}
            style={styleOnAccept}
            disabled={waitingForServerResponse}
          >
            {waitingForServerResponse && (
              <img className="icon" src={LoadingSpinner} alt="spinner" />
            )}
            {labelOnAccept || "Volver a subir documento"}
          </MainButton>
        )}

        {haveCancel && (
          <CancelButton onClick={onCancel} style={styleOnCancel}>
            {waitingForServerResponse && (
              <img className="icon" src={LoadingSpinner} alt="spinner" />
            )}
            {labelOnCancel || "Salir"}
          </CancelButton>
        )}
      </Container>
    </Modal>
  );
}
export default ConfirmModal;
